import { buildApiUrl, buildAssetUrl } from "../../utils/api";

const normalizeCategory = (category) => ({
  ...category,
  id: category.category_id,
  slug: category.slug || "",
  image: buildAssetUrl(category.image),
});

const normalizeSubcategory = (subcategory) => ({
  ...subcategory,
  id: subcategory.subcategory_id,
  image: buildAssetUrl(subcategory.image),
});

export const createCategoriesSlice = (set) => ({
  categories: [],
  subcategories: [],
  selectedCategory: null,
  selectedCategoryData: null,
  categories_loading: false,
  categories_error: null,
  subcategories_loading: false,
  subcategories_error: null,

  fetchCategories: async () => {
    set({ categories_loading: true, categories_error: null });
    try {
      const response = await fetch(buildApiUrl("/api/v1/customer/categories"));
      if (!response.ok) throw new Error('Failed to fetch categories');
      const data = await response.json();
      
      if (data.success) {
        const categories = (data.data || []).map(normalizeCategory);
        set({ categories, categories_loading: false });
        return categories;
      } else {
        throw new Error(data.message || 'Failed to fetch categories');
      }
    } catch (error) {
      set({ categories_error: error.message, categories_loading: false });
      console.error('Error fetching categories:', error);
    }
  },

  fetchSubcategories: async (categoryId) => {
    set({ subcategories_loading: true, subcategories_error: null });
    try {
      const response = await fetch(buildApiUrl(`/api/v1/customer/subcategories?category_id=${categoryId}`));
      if (!response.ok) throw new Error('Failed to fetch subcategories');
      const data = await response.json();
      
      if (data.success) {
        const subcategories = (data.data || []).map(normalizeSubcategory);
        set({ subcategories, subcategories_loading: false });
        return subcategories;
      } else {
        throw new Error(data.message || 'Failed to fetch subcategories');
      }
    } catch (error) {
      set({ subcategories_error: error.message, subcategories_loading: false });
      console.error('Error fetching subcategories:', error);
    }
  },

  setSelectedCategory: (category) => set({
    selectedCategory: category === null || category === 'all' ? category : String(category)
  }),
  setSelectedCategoryData: (categoryData) => set({ selectedCategoryData: categoryData }),
});
